import React from 'react';
import { Route, Switch, Redirect  } from "react-router-dom";
import VisitorPass from './components/visitorPass';
import Login from './components/login';

const isAuthenticated = () => {
  return !!sessionStorage.getItem("userLogged");
};

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

function Routers() {  
  return (
   
    <main>
        <Switch>
            <Route path="/login" component={Login} exact />
            <PrivateRoute path="/visitorpass" component={VisitorPass} exact />
            <PrivateRoute path="/visitorpass/:id" component={VisitorPass} exact />
            <Redirect from="/" to="/login" />
        </Switch>
    </main>
  );
}

export default Routers;
